import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

function equalizeTitles(swiper) {
  const titles = swiper.el.querySelectorAll('.ks-services__title');
  titles.forEach((title) => { title.style.minHeight = ''; });
  if (swiper.params.slidesPerView <= 1) return;
  const maxHeight = Math.max(...Array.from(titles, (title) => title.offsetHeight));
  titles.forEach((title) => { title.style.minHeight = `${maxHeight}px`; });
}

export default function initServicesSlider(selector = '.ks-services__swiper') {
  const sliders = document.querySelectorAll(selector);

  sliders.forEach((el) => {
    const root = el.closest('.ks-services__slider') || el.parentElement;
    const nextEl = root ? root.querySelector('.ks-services__nav-next') : null;
    const prevEl = root ? root.querySelector('.ks-services__nav-prev') : null;

    new Swiper(el, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: { nextEl, prevEl },
      roundLengths: true,   // verhindert 1px-Versatz durch Rahmen
      watchOverflow: true,  // Navigation aus, wenn nichts zu scrollen ist
      breakpoints: {
        768: { slidesPerView: 2 },
        1800: { slidesPerView: 3 },
      },
      on: {
        init: equalizeTitles,
        resize: equalizeTitles,
        breakpoint: equalizeTitles,
      },
    });
  });
}
